import axios from "axios";
import {
  SM_ADMIN_GET_LISTINGS_REQUEST, SM_ADMIN_GET_LISTINGS_SUCCESS, SM_ADMIN_GET_LISTINGS_FAIL,
  SM_ADMIN_GET_LISTING_DETAIL_REQUEST, SM_ADMIN_GET_LISTING_DETAIL_SUCCESS, SM_ADMIN_GET_LISTING_DETAIL_FAIL,
  SM_ADMIN_APPROVE_LISTING_REQUEST, SM_ADMIN_APPROVE_LISTING_SUCCESS, SM_ADMIN_APPROVE_LISTING_FAIL,
  SM_ADMIN_REJECT_LISTING_REQUEST, SM_ADMIN_REJECT_LISTING_SUCCESS, SM_ADMIN_REJECT_LISTING_FAIL,
  SM_ADMIN_GET_TRANSACTIONS_REQUEST, SM_ADMIN_GET_TRANSACTIONS_SUCCESS, SM_ADMIN_GET_TRANSACTIONS_FAIL,
  SM_ADMIN_GET_CONFIG_REQUEST, SM_ADMIN_GET_CONFIG_SUCCESS, SM_ADMIN_GET_CONFIG_FAIL,
  SM_ADMIN_UPDATE_CONFIG_REQUEST, SM_ADMIN_UPDATE_CONFIG_SUCCESS, SM_ADMIN_UPDATE_CONFIG_FAIL,
  SM_ADMIN_DASHBOARD_REQUEST, SM_ADMIN_DASHBOARD_SUCCESS, SM_ADMIN_DASHBOARD_FAIL,
} from "../constants/secondaryMarketConstants";

const getConfig = () => ({
  headers: {
    "Content-type": "application/json",
    "x-access-token": localStorage.getItem("accessToken"),
  },
});

const API = process.env.REACT_APP_API;

export const adminGetListings = (page = 1, limit = 20, status = "") => async (dispatch) => {
  try {
    dispatch({ type: SM_ADMIN_GET_LISTINGS_REQUEST });
    const params = new URLSearchParams({ page, limit });
    if (status) params.append("status", status);
    const { data } = await axios.get(`${API}admin/secondary/listings?${params}`, getConfig());
    dispatch({ type: SM_ADMIN_GET_LISTINGS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: SM_ADMIN_GET_LISTINGS_FAIL, payload: error.response?.data?.message || error.message });
  }
};

export const adminGetListingDetail = (id) => async (dispatch) => {
  try {
    dispatch({ type: SM_ADMIN_GET_LISTING_DETAIL_REQUEST });
    const { data } = await axios.get(`${API}admin/secondary/listings/${id}`, getConfig());
    dispatch({ type: SM_ADMIN_GET_LISTING_DETAIL_SUCCESS, payload: data.data });
  } catch (error) {
    dispatch({ type: SM_ADMIN_GET_LISTING_DETAIL_FAIL, payload: error.response?.data?.message || error.message });
  }
};

export const adminApproveListing = (id) => async (dispatch) => {
  try {
    dispatch({ type: SM_ADMIN_APPROVE_LISTING_REQUEST });
    const { data } = await axios.post(`${API}admin/secondary/listings/${id}/approve`, {}, getConfig());
    dispatch({ type: SM_ADMIN_APPROVE_LISTING_SUCCESS, payload: data.data });
    return data;
  } catch (error) {
    dispatch({ type: SM_ADMIN_APPROVE_LISTING_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

export const adminRejectListing = (id, reason = "") => async (dispatch) => {
  try {
    dispatch({ type: SM_ADMIN_REJECT_LISTING_REQUEST });
    const { data } = await axios.post(`${API}admin/secondary/listings/${id}/reject`, { reason }, getConfig());
    dispatch({ type: SM_ADMIN_REJECT_LISTING_SUCCESS, payload: { id } });
    return data;
  } catch (error) {
    dispatch({ type: SM_ADMIN_REJECT_LISTING_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

export const adminGetTransactions = (page = 1, limit = 20, status = "") => async (dispatch) => {
  try {
    dispatch({ type: SM_ADMIN_GET_TRANSACTIONS_REQUEST });
    const params = new URLSearchParams({ page, limit });
    if (status) params.append("status", status);
    const { data } = await axios.get(`${API}admin/secondary/transactions?${params}`, getConfig());
    dispatch({ type: SM_ADMIN_GET_TRANSACTIONS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: SM_ADMIN_GET_TRANSACTIONS_FAIL, payload: error.response?.data?.message || error.message });
  }
};

export const adminGetConfig = (campaignId) => async (dispatch) => {
  try {
    dispatch({ type: SM_ADMIN_GET_CONFIG_REQUEST });
    const { data } = await axios.get(`${API}admin/secondary/config/${campaignId}`, getConfig());
    dispatch({ type: SM_ADMIN_GET_CONFIG_SUCCESS, payload: data.data });
    return data;
  } catch (error) {
    dispatch({ type: SM_ADMIN_GET_CONFIG_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

export const adminUpdateConfig = (campaignId, configData) => async (dispatch) => {
  try {
    dispatch({ type: SM_ADMIN_UPDATE_CONFIG_REQUEST });
    const { data } = await axios.put(`${API}admin/secondary/config/${campaignId}`, configData, getConfig());
    dispatch({ type: SM_ADMIN_UPDATE_CONFIG_SUCCESS, payload: data.data });
    return data;
  } catch (error) {
    dispatch({ type: SM_ADMIN_UPDATE_CONFIG_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

export const adminGetDashboardStats = () => async (dispatch) => {
  try {
    dispatch({ type: SM_ADMIN_DASHBOARD_REQUEST });
    const { data } = await axios.get(`${API}admin/secondary/dashboard`, getConfig());
    dispatch({ type: SM_ADMIN_DASHBOARD_SUCCESS, payload: data.data });
  } catch (error) {
    dispatch({ type: SM_ADMIN_DASHBOARD_FAIL, payload: error.response?.data?.message || error.message });
  }
};
